<template>
  <div
    v-if="item.id"
    class="sellers-container"
  >
    <el-row class="seller">
      <div
        class="user-image pointer"
        @click="viewUser"
      >
        <vue-load-image v-if="item.file">
          <img
            slot="image"
            :src="item.file.url_view | resizeImage(45, 45)"
            :data-src="item.file.url_view | resizeImage(45, 45)"
          >
          <div
            slot="preloader"
            v-loading="true"
            class="img-loading"
          >
            {{ $t('Loading ....') }}
          </div>
          <div slot="error">
            {{ $t('Network error') }}
          </div>
        </vue-load-image>
        <img
          v-else
          src="../assets/profile-default.png"
        >
      </div>
      <div
        class="user-data pointer"
        @click="viewUser"
      >
        <h3 class="name">
          {{ item.name }}
        </h3>
        <span class="description">{{ item.description }}</span>
      </div>
      <el-button
        v-if="!isMobile"
        type="small"
        class="message"
        icon="icon-massage"
        @click="writeMessage.show = true"
      >
        {{ $t('account-settings.favorites.message') }}
      </el-button>
      <div class="user-favorites">
        <favorite
          v-model="isFavorite"
          :res="'users/favourite'"
          :entity-id="item.id"
          :entity-name="'favorite_user_id'"
          circle
        />
      </div>
    </el-row>
    <el-dialog
      class="categories"
      :title="$t('write-message.dialog.title')"
      :visible.sync="writeMessage.show"
      width="900px"
      center
    >
      <send-message
        :append-data="sendMessageData"
        @done="messageSent"
      >
        <template
          slot="beforeFields"
          slot-scope="{ form, error, change }"
        >
          <el-form-item
            :error="error('ad_id')"
            class="p-b-xs-30"
          >
            <select-primary-js
              resource="ads"
              :resource-options="{filter: userAdsFilters}"
              :placeholder="$t('write-message.ad_id.placeholder')"
              :value="{ id: form.ad_id, name: adSelectionName }"
              @input="() => { form.ad_id = $event.id; adSelectionName = $event.name; change('ad_id') }"
            >
              <template
                slot="singleLabel"
                slot-scope="{ option }"
              >
                {{ option.name || $t('write-message.ad_id.placeholder') }}
              </template>
            </select-primary-js>
          </el-form-item>
        </template>
      </send-message>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import mutations from '@/store/ads/ads.mutationlist';
import Favorite from '@/components/Core/Favorite';
import SelectPrimaryJs from '@/components/MainLeftFilters/SelectPrimaryJs';
import SendMessage from '../components/Ads/SendMessage';

export default {
  name: 'Seller',
  components: {
    Favorite,
    SendMessage,
    SelectPrimaryJs,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    // eslint-disable-next-line vue/require-default-prop,vue/require-prop-types
    state: {},
  },
  data() {
    return {
      writeMessage: {
        show: false,
      },
      favUser: null,
    };
  },
  computed: {
    ...mapState({
      isMobile: state => state.isMobile,
      user: state => state.auth.user,
    }),
    isFavorite: {
      get() {
        return this.favUser;
      },
      set(val) {
        this.favUser = val;
        this.$emit('reloadList');
        this.$store.commit(
          mutations.UPDATE_AD,
          {
            ...this.item,
            favoring_logged_in_user: this.favUser,
          });
      },
    },
    sendMessageData() {
      return this.user && this.item ? {
        user_id: this.user.id,
      } : null;
    },
  },
  watch: {
    item(val) {
      this.favUser = val ? val.favoring_logged_in_user : null;
    },
  },
  mounted() {
    this.favUser = this.item ? this.item.favoring_logged_in_user : null;
  },
  methods: {
    messageSent() {
      this.writeMessage.show = false;
      this.$message({
        showClose: true,
        message: this.$t('message.success'),
        type: 'success',
      });
    },
    viewUser() {
      this.$router.push({ name: 'Profile', params: { id: this.item.id } });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Seller.vue